import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be4e3a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_container" }
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "company-header-right" }
const _hoisted_8 = { class: "ion-activatable ripple-parent header-right-inner" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "star",
  src: "/assets/icon/star_b.png"
}
const _hoisted_11 = {
  key: 1,
  class: "star",
  src: "/assets/icon/star_g.png"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_13 = {
  id: "company__topContainer",
  class: "top-container"
}
const _hoisted_14 = {
  class: "main-center",
  style: { 'background-color': '#ffffff',
                      'color' : '#222'}
}
const _hoisted_15 = { class: "company-info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "gray_divide",
  style: {'color' : '#D9DEE8 !important'}
}, "|", -1))
const _hoisted_17 = { class: "info-left" }
const _hoisted_18 = { class: "info-logo" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_21 = {
  id: "company__mainTab",
  class: "main-tab"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 회사정보 ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 클럽딜 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 토론 ", -1))
const _hoisted_25 = { id: "info_box" }
const _hoisted_26 = {
  key: 0,
  class: "info_container"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "성장성분석 그래프")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray main_13R" }, " 총 인원수, 기업의 서비스 사용자수를 한눈에! ", -1))
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray center main_13R" }, " 이 회사의 고용, 사용자, 재무정보 등 성장지표가 궁금하다면? ", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 혁신의숲에서 자세히보기 ")
const _hoisted_32 = { class: "info_container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "info_container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "news_list" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_41 = { class: "news_list" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_43 = { class: "news_list" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_45 = { class: "news_list" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_47 = { class: "news_list" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수", -1))
const _hoisted_49 = { class: "info_container" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_51 = { class: "item_left" }
const _hoisted_52 = { class: "series" }
const _hoisted_53 = { class: "info_date gray" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "item_right" }
const _hoisted_56 = { class: "strong" }
const _hoisted_57 = { class: "info_container" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_59 = { class: "doc_left" }
const _hoisted_60 = { class: "info_date gray" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "doc_right" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))
const _hoisted_64 = { id: "company__clubeal_box" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buyBox" }, null, -1))
const _hoisted_66 = {
  key: 0,
  class: "card-clubdeal-container"
}
const _hoisted_67 = { class: "clubdeal_title" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 참여 가능한 클럽딜 ")
const _hoisted_69 = { class: "title_18R" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray main_13R description" }, " 진행중인 클럽딜이 마감되기 전에 먼저 참여하세요 ", -1))
const _hoisted_71 = {
  key: 1,
  class: "other-clubdeal-container"
}
const _hoisted_72 = { class: "clubdeal_title space-between" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "다른회사 클럽딜 ", -1))
const _hoisted_74 = { class: "title_18R" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_77 = { class: "clubdeal-badge" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "logo" }
const _hoisted_80 = ["src"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_82 = { class: "collecting" }
const _hoisted_83 = {
  key: 2,
  class: "card-clubdeal-container"
}
const _hoisted_84 = { class: "clubdeal_title" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" 마감된 클럽딜 ")
const _hoisted_86 = { class: "title_18R" }
const _hoisted_87 = {
  key: 3,
  class: "stock_container"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_18B" }, "이 회사 주식 매물 ", -1))
const _hoisted_89 = { class: "title_18R" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock_info" }, " 최저가로 등록된 매물이 먼저 매매됩니다. ", -1))
const _hoisted_91 = { id: "company__board_box" }
const _hoisted_92 = { class: "board_container" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board_tab_info" }, null, -1))
const _hoisted_94 = {
  key: 0,
  class: "write_box"
}
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" 이 회사 어떤가요? ")
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" 의견 작성하기 ")
const _hoisted_97 = {
  key: 1,
  class: "write_box light"
}
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" 의견을 작성하시려면 ")
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" 로그인> ")
const _hoisted_100 = { class: "board_list_container" }
const _hoisted_101 = { id: "company__sell_box" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, null, -1))
const _hoisted_103 = { class: "sell_container" }
const _hoisted_104 = { class: "sell_btn_container" }
const _hoisted_105 = { class: "info_text" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 이 회사 조합지분 팔기 ")
const _hoisted_108 = { class: "sell_btn_container" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 보유주식 팔면 수수료 0원, 100,000P 적립 ", -1))
const _hoisted_110 = ["disabled"]
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" 이 회사 주식 팔기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_icon_s = _resolveComponent("ag-icon-s")!
  const _component_club_deals = _resolveComponent("club-deals")!
  const _component_done_club_deals = _resolveComponent("done-club-deals")!
  const _component_view_my_stake = _resolveComponent("view-my-stake")!
  const _component_board_list = _resolveComponent("board-list")!
  const _component_collect_club_deals = _resolveComponent("collect-club-deals")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "true" }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'뒤로가기'}); _ctx.closeModal();})
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    style: {background: 'white'},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: 'company', 'clickArea':'헤더', 'clickContent': '공유버튼'});_ctx.onShare();})
                  }, [
                    _createVNode(_component_ag_icon, {
                      css: {color: 'gray6', width: 26, height: 26, marginRight: '16px'},
                      name: "arrowRedo"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      style: {background: 'white'},
                      disabled: ~['mna','ipo'].indexOf(_ctx.stockItemInfo.companyStatus),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'관심버튼'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(_ctx.stockItemInfo.stockItemId))})
                    }, [
                      (_ctx.stockItemInfo.likeFlag)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", _hoisted_11))
                    ], 8, _hoisted_9),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ag_box_s, { css: {grow: 1} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {typography: 'num26eb'} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_box_s, { css: {dp: 'flex', alignItems: 'cent정er'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_icon_s, {
                            name: "businessOutline",
                            css: {width: 12, height: 12, color: 'gray3', mr: 4}
                          }),
                          _createVNode(_component_ag_box_s, { css: {typography: 'main14r', color: 'gray2'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 추정 시총 " + _toDisplayString(_ctx.currentValuation?_ctx.currentValuation+'원':'정보 없음'), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ag_icon_s, {
                            name: "helpCircleOutline",
                            css: {width: 20, height: 20, color: 'gray3'},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'추정시가총액툴팁'}); _ctx.openPopover()})
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_box_s, {
                        css: {mt: 8},
                        class: "right-bottom main_14R",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'토론더보기'}); _ctx.changeTab('board')})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_icon_s, {
                            css: {width: 16, height: 16, color: 'green1', mr: 4},
                            name: "angelLeaf"
                          }),
                          _createVNode(_component_ag_box_s, { css: {typography: 'main14r', color: 'green1'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(Number(_ctx.stockItemInfo.avgPoint).toFixed(1)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_16,
                          _createVNode(_component_ag_icon_s, {
                            name: "chatbubble",
                            css: {width: 16, height: 16, color: 'green1', mr: 4}
                          }),
                          _createVNode(_component_ag_box_s, { css: {color: 'green1', typography: 'main14r'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.numberToKorean(_ctx.stockItemInfo.count)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ag_icon_s, {
                            name: "chevronForward",
                            css: {width: 16, height: 16, color: 'green1'}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: _ctx.stockItemInfo.companyLogo ? _ctx.stockItemInfo.companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_19),
                      _hoisted_20
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'info' ? 'select' : '']]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'탭영역', 'clickContent':'회사정보'}); _ctx.changeTab('info')})
              }, [
                _hoisted_22,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'clubdeal' ? 'select' : '']]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'탭영역', 'clickContent':'클럽딜'}); _ctx.changeTab('clubdeal')})
              }, [
                _hoisted_23,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'board' ? 'select' : '']]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'탭영역', 'clickContent':'토론'}); _ctx.changeTab('board')})
              }, [
                _hoisted_24,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_25, [
              _createVNode(_component_ag_box_s, { css: {height: 8, width: '100%', bg: '#F6F8FB'} }),
              (_ctx.stockItemInfo.ifGraphLink && _ctx.stockItemInfo.ifLink)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _createElementVNode("img", {
                      class: "if-graph",
                      src: _ctx.stockItemInfo.ifGraphLink
                    }, null, 8, _hoisted_29),
                    _hoisted_30,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent g_btn",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'성장성분석 그래프', 'clickContent':'혁신의숲에서 자세히보기'}); _ctx.openLink(_ctx.stockItemInfo.ifLink);})
                    }, [
                      _hoisted_31,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _hoisted_34,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.press, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list"
                  }, [
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent",
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'뉴스목록', 'clickContent': info.title}); _ctx.openLink(info.link); }
                    }, [
                      _createTextVNode(_toDisplayString(info.title) + " ", 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_35)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", {
                  class: "company_info",
                  innerHTML: _ctx.stockItemInfo.companyIntroduction
                }, null, 8, _hoisted_38),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.ceo), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.bizno), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.foundDate), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.stockItemInfo.totalStockAmount)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.investHistory, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list space-between"
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, " Series " + _toDisplayString(info.series), 1),
                      _createElementVNode("div", _hoisted_53, _toDisplayString(info.date.split('.')[0] + '.' + info.date.split('.')[1]), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "item_center",
                      innerHTML: info.investor.split('|').map((i)=>{return `<span>${i}</span>`}).join('<br/>')
                    }, null, 8, _hoisted_54),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", _hoisted_56, _toDisplayString(info.value), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.publicAnnouncement, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list space-between"
                  }, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, _toDisplayString(info.date), 1),
                      _createElementVNode("span", {
                        class: "ion-activatable ripple-parent info_link",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'공시자료 목록', 'clickContent': info.title}); _ctx.openLink(info.link)}
                      }, [
                        _createTextVNode(_toDisplayString(info.title) + " ", 1),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_61)
                    ]),
                    _createElementVNode("div", _hoisted_62, _toDisplayString(info.sender), 1)
                  ]))
                }), 128))
              ]),
              _hoisted_63
            ], 512), [
              [_vShow, _ctx.activeTab === 'info']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              (_ctx.collectingAndComingSoon.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.collectingAndComingSoon.length), 1),
                      _hoisted_70
                    ]),
                    _createVNode(_component_ag_box_s, { css: {px: 20} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_club_deals, {
                          list: _ctx.collectingAndComingSoon,
                          "is-login": _ctx.isLogin,
                          onOpen: _cache[9] || (_cache[9] = ({id, title}) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'진행 예정 클럽딜', 'clickContent': title});
                  _ctx.useClubDealProgressModal(id, 'company');
                })
                        }, null, 8, ["list", "is-login"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.anotherCompanyPartnerships.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", null, [
                        _hoisted_73,
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.anotherCompanyPartnerships.length), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent add_btn margin-right",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'다른회사 클럽딜', 'clickContent':'더보기'}); _ctx.clubDealAllOpen=true;})
                      }, [
                        _hoisted_75,
                        _hoisted_76,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anotherCompanyPartnerships, (deal, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId,
                          class: "badge_wrap"
                        }, [
                          _createElementVNode("div", {
                            class: "badge-container",
                            style: _normalizeStyle(_ctx.anotherCompanyPartnerships.length-1 === idx ? {'margin-right' : '20px'} : ''),
                            onClick: () =>{
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'다른회사 클럽딜', 'clickContent':deal.partnershipName})
                    _ctx.useClubDealProgressModal(deal.partnershipId)
                  }
                          }, [
                            _createElementVNode("div", {
                              class: "ion-activatable ripple-parent deal-badge",
                              style: _normalizeStyle({background:deal.bgColor, color:deal.fontColor})
                            }, [
                              _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("img", {
                                  src: deal.companyLogo ? deal.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_80),
                                _hoisted_81
                              ]),
                              _createElementVNode("div", _hoisted_82, _toDisplayString(deal.partnershipName), 1),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 4)
                          ], 12, _hoisted_78)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stockItemPartnershipHistories.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.stockItemPartnershipHistories.length), 1)
                    ]),
                    _createVNode(_component_ag_box_s, { css: {px: 20} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_done_club_deals, { list: _ctx.stockItemPartnershipHistories }, null, 8, ["list"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.diplayStockItemSell.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _createElementVNode("div", null, [
                      _hoisted_88,
                      _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.diplayStockItemSell.length) + "건", 1)
                    ]),
                    _hoisted_90
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.activeTab === 'clubdeal']
            ]),
            _createVNode(_component_view_my_stake, {
              "open-type": _ctx.viewOpenType,
              "is-open": _ctx.viewMyStakeOpen,
              onEdit: _ctx.editMyStake,
              onReload: _ctx.reloadData,
              onClose: _ctx.refreshStakeList
            }, null, 8, ["open-type", "is-open", "onEdit", "onReload", "onClose"]),
            _withDirectives(_createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                (_ctx.hasSession())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _hoisted_95,
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent write_btn",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'의견 작성하기', 'clickContent':'의견 작성 버튼'}); _ctx.openModal({})})
                      }, [
                        _hoisted_96,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                      _hoisted_98,
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$global.openLoginModal()))
                      }, [
                        _hoisted_99,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createVNode(_component_board_list, {
                  "stock-item-id": _ctx.paramsId,
                  parent: "company"
                }, null, 8, ["stock-item-id"])
              ])
            ], 512), [
              [_vShow, _ctx.activeTab === 'board']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.sellAvailableMessage), 1),
                  _createElementVNode("button", {
                    class: "ion-activatable ripple-parent w_btn",
                    disabled: _ctx.isSellAvailable === 'not-available',
                    onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'팔기 상단버튼 영역', 'clickContent':'이 회사 조합지분 팔기'}); (_ctx.user === null ? _ctx.$global.openLoginModal(): _ctx.checkIsLinked())})
                  }, [
                    _hoisted_107,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_106)
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _hoisted_109,
                  _createElementVNode("button", {
                    class: "ion-activatable ripple-parent b_btn",
                    disabled: ~['mna','ipo'].indexOf(_ctx.stockItemInfo.companyStatus),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'팔기 상단버튼 영역', 'clickContent':'이 회사 주식 팔기'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.openSellModal())})
                  }, [
                    _hoisted_111,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_110)
                ])
              ])
            ], 512), [
              [_vShow, _ctx.activeTab === 'sell']
            ])
          ]),
          _createVNode(_component_collect_club_deals, {
            "model-value": _ctx.clubDealAllOpen,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = (value) => _ctx.clubDealAllOpen = value)
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}